import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore'
import { db } from './firebase'

const MAX_ATTEMPTS = 5
const LOCKOUT_MINUTES = 15

const docIdForEmail = (email) => email.trim().toLowerCase()

export const checkLockout = async (email) => {
  if (!email) return { locked: false }
  const ref = doc(db, 'loginAttempts', docIdForEmail(email))
  const snap = await getDoc(ref)
  if (!snap.exists()) return { locked: false }

  const data = snap.data()
  if (data.lockedUntil && data.lockedUntil.toMillis() > Date.now()) {
    const remainingMs = data.lockedUntil.toMillis() - Date.now()
    return { locked: true, remainingMinutes: Math.ceil(remainingMs / 60000) }
  }
  return { locked: false }
}

export const recordFailedAttempt = async (email) => {
  const ref = doc(db, 'loginAttempts', docIdForEmail(email))
  const snap = await getDoc(ref)
  const prevCount = snap.exists() ? (snap.data().failedCount || 0) : 0
  const newCount = prevCount + 1
  const isNowLocked = newCount >= MAX_ATTEMPTS

  await setDoc(ref, {
    failedCount: newCount,
    lastAttemptAt: serverTimestamp(),
    lockedUntil: isNowLocked ? new Date(Date.now() + LOCKOUT_MINUTES * 60000) : null,
  }, { merge: true })

  return {
    failedCount: newCount,
    remainingAttempts: Math.max(0, MAX_ATTEMPTS - newCount),
    isNowLocked,
  }
}

export const clearAttempts = async (email) => {
  const ref = doc(db, 'loginAttempts', docIdForEmail(email))
  try {
    await setDoc(ref, { failedCount: 0, lockedUntil: null, lastAttemptAt: serverTimestamp() })
  } catch {
    // Best-effort cleanup — security rules only allow this once truly
    // authenticated, so a failure here never weakens the lockout.
  }
}
